import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import SelectExercisesNew from "./SelectExercisesNew";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";
import Stars from "../assets/svg/4.5_stars.svg";

import ReactGA from "react-ga";

class BallExercise extends Component {
  state = {
    menuToggled: false,
    exercisesToggled: false,
  };

  setexercisesoff = (wot, arr) => {
    // console.log(this.props.selected_arr);
    //this.props.selected_arr = arr;
    this.setState({ exercisesToggled: wot, exercises: arr });
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    const { exercises } = this.props;

    return (
      <div>
        <Helmet>
          <title>Entraînement avec ballon d'exercice</title>
          <meta
            name="description"
            content="Accédez à des centaines d'exercices vidéo dans le confort de
              maison."
          />
          <meta property="og:url" content="https://www.boxfit-fitness.com/ball-exercises" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="Accédez à des centaines d'exercices vidéo dans le confort de
              maison."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://cdn.fitzet.com/static%2Fballhiplift.jpg?alt=media"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          {/*this.state.menuToggled ? <MenuFunc off={this.setmenuoff} /> : null*/}
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />
          {this.state.exercisesToggled ? (
            <SelectExercisesNew
              exercises={exercises}
              off={this.setexercisesoff}
              cat="Ball"
            />
          ) : null}
          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div className="Screen">
          <div style={{ padding: "55px 20px 20px 20px" }}>
            <h2>Exercise Ball Workout</h2>
            <h3 style={{ fontWeight: 400, marginTop: "-10px" }}>
              Accédez à des centaines d'exercices vidéo dans le confort de
              maison.
            </h3>
            <div style={{ display: "flex" }}>
              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fballballpass.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Glute Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fballhamstringcurls.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Glute Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fballhiplift.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Glute Exercises"
                />
              </div>
            </div>
            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Même si vous êtes nouveau sur <strong>l'exercice Ball</strong> et vous voulez seulement vous exercer ou si vous êtes un pro, ces{" "}
              <strong>exercices premium</strong> sont pour vous.
            </p>
            <p style={{ fontSize: "18px" }}>
              <button
                onClick={() => {
                  this.setState({ exercisesToggled: true });
                }}
                style={{
                  fontSize: "18px",
                  borderColor: "#69C9D0",
                  backgroundColor: "#000",
                  padding: "10px",
                  border: "1px solid",
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                }}
              >
                <span role="img" aria-label="like">
                  👉
                </span>{" "}
                Preview Ball Exercises
              </button>
            </p>
            <h2 style={{ marginTop: "5px" }}>Commencez l'essai de 7 jours gratuit</h2>
            <ul
              className="listaupgrade"
              style={{
                padding: "0px 20px",
                fontSize: "18px",
                marginTop: "-10px",
              }}
            >
              <li>Plus de 390 nouveaux Exercices</li>
              <li>10 Catégories d'exercices</li>
              <li>Historique d'entraînement & Radar de poids</li>
              <li>24/7 Support</li>
              <li>Nouveaux exercices chaque mois</li>
              <li>Annuler quand vous voulez</li>
            </ul>
            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
              >
            
              Avec plus de <strong>390 vidéos d'exercices</strong> pour tous les niveaux et
              durées, nos filtres vous aideront à trouver ce qui est important pour vous aujourd'hui.      <br />
              <br />
              Vous avez juste besoin d'un exercice de Ball ! Commencez votre{" "}
              <strong>essai gratuit de 7 jours</strong> aujourd'hui.
            </p>
            <button
              style={{
                fontSize: "18px",
                background: "#EE1D52",
                padding: "10px",
                border: 0,
                borderRadius: "4px",
                fontWeight: "600",
                width: "100%",
                color: "white",
                marginTop: "10px",
              }}
              onClick={() => {
                ReactGA.event({
                  category: "User",
                  action: "Clicked Free Trial",
                });

                this.props.history.push({
                  pathname: "/register",
                  query: {
                    fromUpgrade: true,
                  },
                });
              }}
            >
              <span role="img" aria-label="like">
                👉
              </span>{" "}
              Essayez gratuitement
            </button>

            <p
              style={{
                fontSize: "18px",
                textAlign: "center",
              }}
            >
              <img src={Stars} alt="reviews" style={{ height: "15px" }} /> Rejoignez plus de 
             <strong>2300</strong> sportifs heutreux
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let exercises = state.firestore.ordered["exercises"];
  let exercise = exercises ? exercises : [];

  return { exercises: exercise };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "exercises",
      where: [["cat", "==", "ball"]],
    },
  ])
)(BallExercise);
